module.exports = __webpack_public_path__ + "media/images/banner-20128b1e1aa02af72e33c67564edfe01.png";